import type {
  HouseFurniture,
} from '../../models/apiTypes';
import {
  adminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPut,
  applyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPut,
  deleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDelete,
} from '../../client';

export function isInvoiceLinkResponse(data: unknown): data is { invoice_link: string } {
  return (
    typeof data === 'object' &&
    data !== null &&
    'invoice_link' in data &&
    typeof (data as { invoice_link: unknown }).invoice_link === 'string'
  );
}

/** Atomic batch of layout changes — see ./state/layoutSync.ts (the only caller). */
export async function applyFurnitureLayout(
  mapObjectId: number,
  items: Array<{ id: number }>,
  keepalive = false,
): Promise<HouseFurniture[]> {
  const { data } = await applyFurnitureLayoutInteriorObjectsInteriorObjectIdFurnitureLayoutPut({
    path: { interior_object_id: mapObjectId },
    body: { items },
    throwOnError: true,
    // Lets the request outlive the page when it is flushed on pagehide.
    keepalive,
  });
  return data.items;
}

export async function updateFurnitureCatalogTiles(
  catalogId: number,
  footprintTiles: [number, number][] | null,
  surfaceTiles: [number, number][] | null,
  clearFootprint = false,
  clearSurface = false,
  wallFloorOffset?: number,
): Promise<{ message: string }> {
  const body: Record<string, unknown> = {
    footprint_tiles: footprintTiles,
    surface_tiles: surfaceTiles,
    clear_footprint: clearFootprint,
    clear_surface: clearSurface,
  };
  if (wallFloorOffset !== undefined) body.wall_floor_offset = wallFloorOffset;
  const { data } = await adminUpdateFurnitureCatalogTilesAdminFurnitureCatalogCatalogIdTilesPut({
    path: { catalog_id: catalogId },
    body,
    throwOnError: true,
  });
  return data;
}

export async function deleteCobweb(interiorObjectId: number, cobwebId: number): Promise<void> {
  await deleteCobwebInteriorObjectsInteriorObjectIdCobwebsCobwebIdDelete({
    path: { interior_object_id: interiorObjectId, cobweb_id: cobwebId },
    throwOnError: true,
  });
}
